import { Box, Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';

interface Props {
  engagements?: string;
  followers?: string;
}

const CardByFollower: React.FC<Props> = ({ followers, engagements }) => {
  const totalEngagements = Number(engagements) || 0;
  const followerEngagements = Number(followers) || 0;

  let followersPercent = 0;
  let nonFollowersPercent = 0;

  if (totalEngagements > 0) {
    followersPercent = Math.round(
      (followerEngagements / totalEngagements) * 100
    );
    nonFollowersPercent = Math.max(0, 100 - followersPercent);
  }

  const chartData = {
    datasets: [
      {
        data: [followersPercent, nonFollowersPercent],
        backgroundColor: ['#FF0050', '#25CCC8'],
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    cutout: '80%',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    maintainAspectRatio: false,
  };

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: '436px',
        minHeight: '191px',
        borderRadius: '20px',
        bgcolor: '#FFFFFF',
        // px: { xs: 3, md: 5 },
        pt: { xs: 3, md: 4 },
      }}
    >
      <Typography
        sx={{
          color: '#202124',
          textAlign: 'center',
          fontSize: { xs: '18px', md: '20px' },
          fontWeight: 400,
          lineHeight: 1.15,
          // mb: { xs: 3, md: 4 },
        }}
      >
        Engagement by Followers
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 6 },
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ position: 'relative', width: 140, height: 220, flexShrink: 0 }}>
          <Doughnut data={chartData} options={chartOptions} />
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#7B7B7B',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1,
              }}
            >
              {totalEngagements}
            </Typography>
            <Typography
              sx={{
                color: '#202124',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1,
                mt: 1,
              }}
            >
              Total
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            minWidth: { xs: '100%', sm: 'auto' },
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#7B7B7B',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1.1,
                ml:3.5
              }}
            >
              {followersPercent}%
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  bgcolor: '#FF0050',
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  color: '#202124',
                  fontSize: { xs: '18px', md: '20px' },
                  fontWeight: 400,
                  lineHeight: 1.05,
                }}
              >
                Followers
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                color: '#7B7B7B',
                fontSize: { xs: '18px', md: '20px' },
                fontWeight: 400,
                lineHeight: 1.1,
                ml:3.5
              }}
            >
              {nonFollowersPercent}%
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  bgcolor: '#25CCC8',
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  color: '#202124',
                  fontSize: { xs: '18px', md: '20px' },
                  fontWeight: 400,
                  lineHeight: 1.05,
                }}
              >
                Non Followers
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CardByFollower;
